






















import { defineComponent, watch, onMounted, onBeforeUnmount, toRefs, PropType, nextTick } from '@vue/composition-api';
import { useTextareaTypoHandler } from '../hooks';
import { typeTypoModel } from '../types';

const name = 'ttam-ad-text-typo-model';
export default defineComponent({
  name,
  props: {
    domId: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    // 错别字模型
    typoModel: {
      type: Array as PropType<typeTypoModel[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { domId, value, typoModel, maxLength } = toRefs(props);
    const { divDom, textAreaLineHeight, templateTypoModel, initTextWrap, dealReplace, getTypoPosition } =
      useTextareaTypoHandler({
        domId,
        titleValue: value,
        typoModel,
        maxLength,
      });
    const computedStyle = item => ({
      height: textAreaLineHeight.value,
      width: `${item.width}px`,
      left: `${item.left}px`,
      top: `${item.top}px`,
    });
    const replaceCorrectSpelling = index => {
      // 更新值
      emit(
        'input',
        dealReplace(
          props.value,
          props.typoModel[index].startIndex,
          props.typoModel[index].endIndex,
          props.typoModel[index].correctSpelling,
        ),
      );
      // 触发重新检验
      nextTick(() => {
        emit('reCheck');
      });
    };
    const handleMouseenter = () => {
      emit('mouse-enter-typo-item');
    };
    watch(
      () => props.typoModel,
      () => {
        getTypoPosition();
      },
    );
    onMounted(() => {
      initTextWrap();
    });
    onBeforeUnmount(() => {
      if (divDom.value) {
        document.body.removeChild(divDom.value);
      }
    });
    return {
      name,
      // TypoModel错误模型相关逻辑
      templateTypoModel,
      computedStyle,
      replaceCorrectSpelling,
      handleMouseenter,
    };
  },
});
